/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MaterialTreeNodeViewModel } from "../types/MaterialTreeNodeViewModel.ts";
import { materialItemViewModelSchema } from "./materialItemViewModelSchema.ts";

export const materialTreeNodeViewModelSchema = z.object({
  folderId: z.number().int().nullish(),
  folderTitle: z.string().nullish(),
  parentFolderId: z.number().int().nullish(),
  subFolders: z.array(z.lazy(() => materialTreeNodeViewModelSchema)).nullish(),
  materials: z.array(z.lazy(() => materialItemViewModelSchema)).nullish(),
}) as unknown as ToZod<MaterialTreeNodeViewModel>;
